import React from 'react'
import { Flex, Spinner } from '@chakra-ui/react'

export const Loading = props => (
  <Flex {...props} flex={1} height='100%' align='center' justify='center'>
    <Spinner size='xl' />
  </Flex>
)

export default Loading
